export function toggleDisableButton() {
  return {
    type: "@disableButtons/TOGGLE",
  };
}
